/**
 * @class
 * @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();

      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      this.links = this.querySelectorAll('.social:not(.clipboard):not(.whatsapp)');
      this.whatsappLink = this.querySelector('.whatsapp');
      this.clipboardButton = this.querySelector('.clipboard');

      this.dynamicProduct = this.dataset.dynamicProduct === 'true';
      this.shareTitle = this.dataset.shareTitle || document.title;

      this.setupEventListeners();

      if (this.dynamicProduct) {
        document.addEventListener('product:variant-change', this.handleVariantChange);
        this.updateUrl(window.location.href);
      }
    }

    disconnectedCallback() {
      if (this.dynamicProduct) {
        document.removeEventListener('product:variant-change', this.handleVariantChange);
      }
    }

    setupEventListeners() {
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          let left = (screen.width / 2) - (640 / 2),
            top = (screen.height / 2) - (440 / 2) - 100;

          window.open(
            link.getAttribute('href'),
            'mywin',
            'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0'
          );

          event.preventDefault();
        });
      });
    }

    handleVariantChange() {
      requestAnimationFrame(() => {
        this.updateUrl(window.location.href);
      });
    }

    updateUrl(url) {
      if (!url) return;

      const shareUrl = new URL(url, window.location.origin);

      if (shareUrl.origin !== window.location.origin) {
        return;
      }

      const cleanShareUrl = `${shareUrl.origin}${shareUrl.pathname}${shareUrl.search}`;

      const facebookLink = this.querySelector('.facebook');
      if (facebookLink) {
        facebookLink.href =
          'http://www.facebook.com/sharer.php?u=' +
          encodeURIComponent(cleanShareUrl);
      }

      const twitterLink = this.querySelector('.twitter');
      if (twitterLink) {
        twitterLink.href =
          'https://twitter.com/intent/tweet?text=' +
          encodeURIComponent(this.shareTitle) +
          '&url=' +
          encodeURIComponent(cleanShareUrl);
      }

      const pinterestLink = this.querySelector('.pinterest');
      if (pinterestLink) {
        const pinterestUrl = new URL(pinterestLink.href);
        pinterestUrl.searchParams.set('url', cleanShareUrl);
        pinterestLink.href = pinterestUrl.toString();
      }

      if (this.whatsappLink) {
        this.whatsappLink.href =
          'whatsapp://send?text=' +
          encodeURIComponent(`${this.shareTitle}, ${cleanShareUrl}`);
      }

      if (this.clipboardButton) {
        this.clipboardButton.dataset.shareUrl = cleanShareUrl;
      }
    }
  }

  customElements.define('social-share', SocialShare);
}